import axios from 'axios';

export class OnboardingService {
    static getUrl = url => process.env.baseHref + url;

    static getOnboardingStatus() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/onboarding/v2/status')
        });
    }

    static setOnboardingStatus(onboardingStatus) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/onboarding/v2/status'),
            data: { onboardingStatus }
        });
    }

    static getUserSettings() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/onboarding/v2/user-settings')
        });
    }

    static getUserSettingsFromSessionStorage() {
        let userSettings = sessionStorage.getItem('w-auth-user-settings');
        if (userSettings) {
            userSettings = JSON.parse(userSettings);
            return new Promise(resolve => resolve({ data: userSettings }));
        } else {
            return axios({
                method: 'GET',
                url: this.getUrl('/api/onboarding/v2/user-settings')
            });
        }
    }

    static setUserBackupEmail(privateEmail) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/onboarding/v2/user-settings'),
            data: { privateEmail }
        });
    }

    static setUserDataTags(dataTags) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/onboarding/v2/user-settings'),
            data: { dataTags }
        });
    }

    static getRandomPhotos(number) {
        return axios({
            method: 'GET',
            url: this.getUrl(`/api/onboarding/v2/user-settings/photos/random?$top=${number}`)
        });
    }

    static setUserProfilePhoto(photoData) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/onboarding/v2/user-settings/photo'),
            data: photoData
        });
    }

    static setUserPassword(newPassword) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/onboarding/v2/password'),
            data: { newPassword }
        });
    }

    static sendDownloadAppLinkToPhone(phoneNumber) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/onboarding/v2/send-download-link'),
            data: { phoneNumber }
        });
    }

    static clearOnboardingSessionStorage() {
        sessionStorage.removeItem('w-auth-user-settings');
        sessionStorage.removeItem('w-auth-company-settings');
        sessionStorage.removeItem('w-auth-company-logo-url');
        sessionStorage.removeItem('w-auth-help-info');
    }

    static preloadCompanyLogo(url) {
        return axios({
            method: 'GET',
            url: this.getUrl(url)
        });
    }

    static sendBypassEmail() {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/onboarding/v2/bypass-mobile-install')
        });
    }

    static getActivationCode() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/auth/v2/activation-code')
        });
    }

    static getApplications() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/online/v1/apps')
        });
    }
}




// WEBPACK FOOTER //
// ./node_modules/@webapp/preact-shared/services/onboardingService.js